/** Workspace feature flag storing a custom display name for the division structure in Explore. */
export const DIVISIONS_IN_EXPLORE_LABEL_FLAG = "divisionsInExploreLabel";

/** Default section heading for the division structure in the Explore sidebar. */
export const DEFAULT_DIVISIONS_LABEL = "Divisions";
